import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Bell, Package, RefreshCw, Mail, FileText } from "lucide-react";

const typeMeta = {
  STOCK_ALERT: { icon: Package, label: "Stock Alert", cls: "border-emerald-500/40 text-emerald-400" },
  REORDER_REMINDER: { icon: RefreshCw, label: "Reorder Reminder", cls: "border-[#D4AF37]/40 text-[#D4AF37]" },
  ORDER_RECEIPT: { icon: FileText, label: "Order Receipt", cls: "border-sky-500/40 text-sky-400" },
};

export default function Notifications() {
  const [notifs, setNotifs] = useState([]);
  const [filter, setFilter] = useState("");

  const load = () => api.get("/admin/notifications", { params: filter ? { ntype: filter } : {} }).then(({ data }) => setNotifs(data));
  useEffect(() => { load(); const t = setInterval(load, 10000); return () => clearInterval(t); /* eslint-disable-next-line */ }, [filter]);

  return (
    <div>
      <div className="flex items-center gap-3">
        <Bell className="h-6 w-6 text-[#D4AF37]" />
        <h1 className="font-serif-display text-3xl font-bold text-slate-50">Notifications Log</h1>
      </div>
      <p className="mt-1 text-sm text-[#94A3B8]">Every stock alert & reorder reminder sent to retailers. Email delivery is currently <span className="text-[#D4AF37]">log-only</span> — these are the messages that would be emailed.</p>

      <div className="mt-6 flex gap-2">
        {[["", "All"], ["STOCK_ALERT", "Stock Alerts"], ["REORDER_REMINDER", "Reorder Reminders"]].map(([v, l]) => (
          <button key={l} data-testid={`notif-filter-${l.replace(/\s/g, "-").toLowerCase()}`} onClick={() => setFilter(v)}
            className={`rounded-full border px-4 py-2 text-sm ${filter === v ? "border-[#D4AF37] bg-[#D4AF37]/10 text-[#D4AF37]" : "border-[#2A2E39] text-slate-300"}`}>{l}</button>
        ))}
      </div>

      <div className="mt-8 overflow-x-auto rounded-2xl border border-[#2A2E39]">
        <table className="w-full text-left text-sm">
          <thead className="bg-[#121418] text-xs uppercase tracking-wider text-[#64748B]">
            <tr>{["Type", "Recipient", "Message", "Channel", "Status", "Sent"].map((h) => <th key={h} className="whitespace-nowrap px-4 py-3">{h}</th>)}</tr>
          </thead>
          <tbody className="divide-y divide-[#2A2E39]">
            {notifs.map((n) => {
              const m = typeMeta[n.type] || typeMeta.STOCK_ALERT;
              return (
                <tr key={n.id} data-testid={`admin-notif-${n.id}`} className="mc-table-row">
                  <td className="px-4 py-3"><span className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[10px] font-bold ${m.cls}`}><m.icon className="h-3 w-3" /> {m.label}</span></td>
                  <td className="whitespace-nowrap px-4 py-3 text-slate-100">{n.user_email}</td>
                  <td className="px-4 py-3 text-[#94A3B8]"><div className="font-medium text-slate-200">{n.title}</div><div className="text-xs">{n.body}</div></td>
                  <td className="px-4 py-3"><span className="inline-flex items-center gap-1 text-[#94A3B8]"><Mail className="h-3.5 w-3.5" /> {n.channel}</span></td>
                  <td className="px-4 py-3"><span className={`rounded-full border px-2 py-0.5 text-[10px] font-bold ${n.status === "SENT" ? "border-emerald-500/40 text-emerald-400" : n.status === "FAILED" ? "border-rose-500/40 text-rose-400" : "border-amber-500/40 text-amber-400"}`}>{n.status}</span></td>
                  <td className="whitespace-nowrap px-4 py-3 text-xs text-[#94A3B8]">{new Date(n.created_at).toLocaleString("en-IE")}</td>
                </tr>
              );
            })}
            {notifs.length === 0 && <tr><td colSpan={6} className="px-4 py-10 text-center text-[#64748B]">No notifications logged yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
